import React, { useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { commonPath, universalPath } from '../fieldPath';
import { PCPDUrationUnit } from '../../../Components/helper';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../Components/Utility/FilterAction/BtnDelete';

function CustomNotification(props) {
  const { cardEle, cardIndex, handleChange, addEditAccess } = props;
  const [limitReached, setLimitReached] = useState(false);
  const { t } = useTranslation('common');

  const addDuration = () => {
    if (cardEle?.customDurations?.length < 6) {
      cardEle?.customDurations?.push({ durationUnit: null, durationValue: null, emailNotification: false });
      handleChange(cardEle?.customDurations, commonPath(cardIndex, 'customDurations').COMMON, cardIndex);
    } else {
      setLimitReached(true);
    }
  };
  const deleteCustomNotification = (i) => {
    cardEle?.customDurations?.splice(i, 1);
    if (cardEle?.customDurations?.length === 0) {
      cardEle?.customDurations?.push({ durationUnit: null, durationValue: null, emailNotification: false }); // this is for clearing the last custom seclection
    }
    handleChange(cardEle?.customDurations, commonPath(cardIndex, 'customDurations').COMMON, cardIndex);
  };

  return (
    <div className="collapse-card add-bom-accordion">
      <Accordion key={`Column_${cardIndex}`}>
        <Card className="bom-add-card ">
          <Card.Header className="bgcolor-dark rounded-0 ">
            <div className="d-align-items-center reducing-switch-z-index mr-16">
              <div className="d-inline-flex align-items-center design-switch">
                <input
                  type="checkbox"
                  className="form-check-input comment-switch-input"
                  id={`customNotifications_${cardIndex}`}
                  name={`customNotifications_${cardIndex}`}
                  onChange={(e) =>
                    !e?.target?.checked
                      ? handleChange(e?.target?.checked, commonPath(cardIndex, 'CustomNotificationSwitch').COMMON, cardIndex, ['customDurations'])
                      : handleChange(e?.target?.checked, commonPath(cardIndex, 'CustomNotificationSwitch').COMMON, cardIndex)
                  }
                  disabled={!cardEle?.dependentObj?.dependentSwitch}
                  checked={cardEle?.CustomNotificationSwitch}
                />
                <label className="switch-text font-heavy align-items-center mt-03" htmlFor={`customNotifications_${cardIndex}`}>
                  {t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.CUSTOM_NOTIFICATION_SWITCH')}
                </label>
              </div>
            </div>
            <span className="d-flex align-items-center ml-auto">
              <div className="btn-outline-container btn-noborder ">
                <BtnAdd onBtnClick={addDuration} addEditAccess={addEditAccess} forDisable={!cardEle?.CustomNotificationSwitch} />
              </div>
              <span className="icon-new-down-arrow-icon" />
            </span>
          </Card.Header>
          {cardEle?.CustomNotificationSwitch && (
            <Card.Body>
              <div className="flex-fill ">
                {cardEle?.customDurations?.map((cdEle, cdIndex) => {
                  return (
                    <div key={cdEle} className="d-flex align-items-center mb-2">
                      <div className="common-checkbox">
                        <input
                          onChange={(e) =>
                            handleChange(e?.target?.checked, universalPath(cardIndex, 'customDurations', cdIndex, 'emailNotification').COMMON, cardIndex)
                          }
                          name={`check_${cdIndex}_${cardIndex}`}
                          id={`check_${cdIndex}_${cardIndex}`}
                          type="checkbox"
                          checked={cdEle?.emailNotification}
                          disabled={!addEditAccess}
                        />
                        <label
                          htmlFor={`check_${cdIndex}_${cardIndex}`}
                          className="chklabel"
                          title={t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.EMAIL_NOTIFICATION')}
                        />
                      </div>
                      <div className="w-50  mx-3">
                        <div className="common-input-control mb-0">
                          <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.DURATION_QUANTITY')}</p>
                          <input
                            name="durationQuantity"
                            value={cdEle?.durationValue}
                            type="number"
                            className="form-control"
                            onChange={(e) => {
                              if (/^\s*$|^[1-9]\d*$/.test(e?.target?.value)) {
                                handleChange(e?.target?.value, universalPath(cardIndex, 'customDurations', cdIndex, 'durationValue').COMMON, cardIndex);
                              }
                            }}
                            disabled={!addEditAccess}
                          />
                        </div>
                        {cardEle.hasError && !cdEle?.durationValue && (
                          <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.DURATION_QUANTITY_REQUIRED')}</span>
                        )}
                      </div>
                      <div className="w-50 mr-3 mb-0 common-react-select">
                        <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.DURATION_UNIT')}</p>
                        <Select
                          name="durationUnit"
                          options={PCPDUrationUnit}
                          getOptionLabel={(option) => `${option.label}`}
                          getOptionValue={(option) => `${option.name}`}
                          maxMenuHeight={140}
                          menuPosition="fixed"
                          value={cdEle?.durationUnit}
                          className="common-select"
                          classNamePrefix="common-select"
                          isClearable
                          onChange={(e) => handleChange(e, universalPath(cardIndex, 'customDurations', cdIndex, 'durationUnit').COMMON, cardIndex)}
                          placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.SELECT_DURATION_UNIT')}
                          disabled={!addEditAccess}
                          menuShouldBlockScroll
                          menuShouldScrollIntoView
                        />
                        {cardEle.hasError && !cdEle?.durationUnit && (
                          <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.DURATION_UNIT_REQUIRED')}</span>
                        )}
                      </div>
                      <div className="btn-outline-container align-self-end">
                        <BtnDelete multiDelete={() => deleteCustomNotification(cdIndex)} />
                      </div>
                    </div>
                  );
                })}
              </div>
              {limitReached && <div className="text-danger f-14">{t('PRODUCT_CRITICAL_PATH.MODAL.CUSTOM_NOTIFICATION.CUSTOM_NOTIFICATION_LIMIT_REACHED')}</div>}
            </Card.Body>
          )}
        </Card>
      </Accordion>
    </div>
  );
}
export default CustomNotification;
